import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrMeasureIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M23.71 6.04L17.96 0.290005C17.58 -0.0899951 16.92 -0.0899951 16.55 0.290005L0.289998 16.55C-0.100002 16.92 -0.100002 17.59 0.289998 17.96L6.04 23.71C6.43 24.1 7.06 24.1 7.45 23.71L23.71 7.45C24.1 7.06 24.1 6.43 23.71 6.04ZM6.74 21.58L2.41 17.25L4.25 15.41L6.17 17.33C6.56 17.72 7.19 17.72 7.58 17.33C7.97 16.94 7.97 16.31 7.58 15.92L5.66 14L7.5 12.16L9.42 14.08C9.81 14.47 10.44 14.47 10.83 14.08C11.22 13.69 11.22 13.06 10.83 12.67L8.91 10.75L10.75 8.91L12.67 10.83C13.06 11.22 13.69 11.22 14.08 10.83C14.47 10.44 14.47 9.81001 14.08 9.42L12.16 7.5L14 5.66L15.92 7.58C16.31 7.97 16.94 7.97 17.33 7.58C17.72 7.19 17.72 6.56 17.33 6.17L15.41 4.25L17.25 2.41001L21.58 6.74L6.74 21.58Z" fill={color}/>
  </BaseIcon>
));

AttrMeasureIcon.displayName = 'AttrMeasureIcon';
